export const INTEGRATION_LABELS = {
  automaster: 'AMS',
  idms: 'IDMS',
  emotive: 'Emotive',
  loanpro: 'LoanPro',
  loantec: 'LoanTec',
  rent_manager: 'Rent Manager'
}

export const DEFAULT_INTEGRATION_LABEL = 'DMS'

export function integrationLabel(merchant) {
  const type = merchant?.integration_type
  if (!type) return DEFAULT_INTEGRATION_LABEL

  return (
    INTEGRATION_LABELS[String(type).toLowerCase()] || DEFAULT_INTEGRATION_LABEL
  )
}
